<script>
  import {getHomepage} from "../api/homepage";

  import {onMount} from "svelte";
  import {marked} from "marked";
  import { UPLOADS_DIRECTORY } from "../constants";

  let data = null;

  onMount(async() => {
    try {
      data = await getHomepage();
    } catch(error) {
      console.error(error);
    }
  });
</script>

{#if data}
    <div id="anchor-download" class="container-fluid block">
        <div class="row box">
            <h1 class="title text-center col-12">{data.download_header}</h1>
            <p
                    class="description col-md-4 offset-md-4 col-lg-6 offset-lg-3 text-center my-4"
            >
                {@html marked(data.download_description)}
            </p>
            <div
                    class="col-12 col-lg-10 col-xl-8 offset-xl-2 offset-lg-1 row download-buttons"
            >
                {#each data.downloads as download}
                    <div class="col-md-4">
                        <a href="{UPLOADS_DIRECTORY}{download.file.data.attributes.url}" download
                        >
                            <button
                                    data-nosnippet
                                    data-aos="flip-up"
                                    data-aos-offset="200"
                                    class="btn-download col-8 offset-2 mt-4"
                            >POBIERZ <i class="ci-download ms-2"></i></button
                            >
                        </a>
                        <h3 class="mt-2">
                            {@html download.title.replaceAll("\\n", "<br>")}
                        </h3>
                    </div>
                {/each}
            </div>
        </div>
    </div>
{/if}

<style>
    a {
        text-decoration: none;
    }

    .box {
        margin: 0 !important;
    }

    .block {
        display: flex;
        align-items: center;
        min-height: 100vh;
        padding: 0 !important;
        overflow-y: visible;
    }

    .title {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
    }

    .description {
        font-family: "Work Sans";
        font-size: 14px;
        line-height: 16px;

        color: #425466;
    }

    .btn-download {
        border: none;
        outline: none;
        background-color: #fdcd18;
        color: #425466;
        font-family: "Montserrat";
        font-weight: bold;
        font-size: 24px;
        padding: 15px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
    }

    .btn-download i {
        font-size: 28px;
    }

    h3 {
        font-family: Work Sans;
        font-weight: 700;
        font-size: 16px;
        text-align: center;
        text-transform: uppercase;
    }

    @media only screen and (max-width: 576px) {
        .download-buttons {
            margin: 0;
            padding: 0;
        }
    }
</style>
